/**
 * Created by shubham on 19/11/18.
 */

import { Routes, RouterModule }  from '@angular/router';
import { RequestBusinessUnitComponent} from './request-business-unit.component';
import { AddBusinessUnitForUserComponent } from './add-business-unit/add-business-unit.component';
import { BusinessUnitListForUserComponent } from './business-unit-list/business-unit-list.component';
import { ViewBusinessUnitForUserComponent } from './view-business-unit/view-business-unit.component';

export const RequestBusinessUnitRoutes: Routes = [
    {
        path: '',
        component: RequestBusinessUnitComponent,
        children: [
            { path: '', redirectTo: '/app/partners-dashboard', pathMatch: 'full' },
            { path: 'list', component: BusinessUnitListForUserComponent },
            { path: 'add', component: AddBusinessUnitForUserComponent },
            { path: 'view/:id', component: ViewBusinessUnitForUserComponent }
        ]
    }
];

export const RequestBusinessUnitRoutingModule = RouterModule.forChild(RequestBusinessUnitRoutes);


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-operations/request-business-unit/request-business-unit-routing.module.ts